function doObjectToFormData(object, prefixTemplate = null, formData = null) {
    if (formData === null) {
        formData = new FormData();
    }

    if (Array.isArray(object)) {
        for (let i = 0; i < object.length; ++i) {
            const parsedTemplate = prefixTemplate ? prefixTemplate.replace('%key%', i) : i.toString();

            if (Array.isArray(object[i])) {
                const template = `${parsedTemplate}[${i}][%key%]`;
                doObjectToFormData(object[i], template, formData);
            } else if (typeof object[i] === 'object') {
                const template = `${parsedTemplate}[%key%]`;
                doObjectToFormData(object[i], template, formData);
            } else {
                formData.append(parsedTemplate, object[i]);
            }
        }
    } else if (typeof object === 'object') {
        Object.entries(object).forEach(pair => {
            const key = pair[0];
            const value = pair[1];

            const parsedTemplate = prefixTemplate ? prefixTemplate.replace('%key%', key) : key;

            if (value !== null && (Array.isArray(value) || typeof value === 'object')) {
                const template =  `${parsedTemplate}[%key%]`;
                doObjectToFormData(value, template, formData);
            } else {
                formData.append(parsedTemplate, value);
            }
        });
    }

    return formData;
}

export function objectToFormData(object, prefixTemplate = null, formData = null) {
    if (typeof object !== 'object' && !Array.isArray(object)) {
        return null;
    }

    return doObjectToFormData(object, prefixTemplate, formData);
}
